module.exports = __webpack_public_path__ + "img/fourth-world-bg.a260c345.png";